export default {
    baseApiURL: '/api',
    baseURL: '',
    app: undefined,
    useRoutesName: [],
    register(vm) {
        this.app = vm;
    }
};
